import { MapService } from './services/map.service.es6'

export default {
  namespaced: true,

  state: {

    elements: null,
    selected: null,
    locked: true

  },
  getters: {

    alarms: (state, getters, rootState) => rootState.items.alarms || [],

    assets: (state, getters, rootState) => rootState.items.assets || [],

  },
  mutations: {

    initialize (state) {
      state.elements = null
    },

    elements (state, elements) {
      state.elements = elements
    },

    selected (state, selected) {
      state.selected = selected
    },

    locked (state, locked) {
      state.locked = locked
      state.selected = null
    }

  },

  actions: {

    async initialize({ commit, dispatch, state, getters }) {
      commit('initialize')

      const [ elements ] =  await Promise.all([
        dispatch('getItems', { model: { name: 'map-elements' } }, { root: true }),
        !this.alarms ? dispatch('getItems', { model: { name: 'alarms' } }, { root: true }) : null,
        !this.assets ? dispatch('getItems', { model: { name: 'assets' } }, { root: true }) : null
      ])

      elements.forEach(element => MapService.updateElementStatus(element))

      commit('elements', elements)
    },

    select ({ commit, dispatch, state }, element) {
      commit('selected', element)
    },

    lock ({ commit }, locked) {
      commit('locked', locked)
    },

    async find ({ dispatch, rootState }, id) {
      await dispatch('getItem', { modelName: 'map-elements', id: id }, { root: true })

      return rootState.item['map-elements']
    },

    async save ({ dispatch, commit, state }, element) {
      [ 'createdAt', 'updatedAt', 'deletedAt' ].forEach(prop => delete element[prop])

      const result = await dispatch('updateItem', { modelName: 'map-elements', item: element }, { root: true })

      if (!element.id) {
        MapService.updateElementStatus(result)
        state.elements.push(result)
        commit('elements', state.elements)
      }
    },

    async remove ({ dispatch, commit, state }, element) {
      if (element.id)
        dispatch('destroyItem', { model: { name: 'map-elements' }, id: element.id }, { root: true })

      state.elements.splice(state.elements.indexOf(element), 1)
      commit('elements', state.elements)
      commit('selected', null)
    },
  }
}
